import React, { useMemo, useState } from "react";
import styles from './index.module.scss'
import FadeIn from "@/compoments/fadeIn";
import BaseInfo from "./baseInfo";
import AccountSecurity from "./accountSecurity";
import TopInfo from "./topInfo";
import { useUserInfo } from "@/api/request";
import LoadingUI from "@/compoments/loadingUI";
import classNames from "classnames";

const PersonalInfo = () => {

    const { isLoading , data  } = useUserInfo()

    return <FadeIn>
        <div className={styles.main}>
            <LoadingUI loading={isLoading} data={data} height={700}>
                <div>
                    <TopInfo />
                </div>

                <div className={styles.line} />

                <div className={styles.marginTop}>
                    <BaseInfo />
                </div>

                <div className={styles.line} />

                <div className={classNames(styles.marginTop , styles.marginBottom)}>
                    <AccountSecurity />
                </div>
            </LoadingUI>

        </div>
    </FadeIn>
}
export default PersonalInfo